import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight, Ticket } from 'lucide-react';
import { Button } from '../ui/Button';

export function TicketPreview({
  ticketNumbers,
  ticketCount,
  title = 'เลขตั๋วของคุณ',
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const TICKETS_PER_PAGE = 5;

  useEffect(() => {
    setCurrentPage(1);
  }, [ticketCount]);

  if (!ticketNumbers.length) return null;

  const totalPages = Math.ceil(ticketCount / TICKETS_PER_PAGE);
  const startIndex = (currentPage - 1) * TICKETS_PER_PAGE;
  const endIndex = startIndex + TICKETS_PER_PAGE;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Ticket className="h-5 w-5 text-brand-red" />
        <h4 className="font-semibold text-gray-800">{title}</h4>
      </div>

      {totalPages > 1 && (
        <div className="flex flex-col items-start justify-between gap-3 rounded-lg bg-gray-50 p-3 sm:flex-row sm:items-center">
          <p className="text-xs text-gray-600 sm:text-sm">
            แสดงตั๋ว {startIndex + 1}-{Math.min(endIndex, ticketCount)} จาก{' '}
            {ticketCount}
          </p>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
            >
              <ChevronLeft className="h-4 w-4" />
            </Button>
            <span className="text-xs text-gray-600">
              หน้า {currentPage}/{totalPages}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() =>
                setCurrentPage(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
            >
              <ChevronRight className="h-4 w-4" />
            </Button>
          </div>
        </div>
      )}

      <div className="space-y-2 grid grid-cols-5 gap-2">
        {ticketNumbers.slice(startIndex, endIndex).map((number, idx) => {
          const actualIndex = startIndex + idx;

          return (
            <div
              key={actualIndex}
              className="rounded-xl border border-red-100 bg-gradient-to-r from-white to-red-50/50 p-4"
            >
              <p className="text-xs text-gray-500">ตั๋วที่ {actualIndex + 1}</p>
              <p className="mt-2 font-mono text-2xl font-bold tracking-widest text-brand-red">
                {number}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
